// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-icon[data-v-38e33be8]{display:inline-block;width:1em;height:1em;font-size:1em;line-height:1em}.loading-icon.rotate[data-v-38e33be8]{animation:loading-icon-rotate-38e33be8 1s linear infinite}@keyframes loading-icon-rotate-38e33be8{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
